import { useRef } from "react";

const useNumberInputData = ({ value, disabled, onChange }) => {
  // Create a ref for the input element
  const inputRef = useRef(null);
  // Function to calculate the width of the input element
  const calculateInputWidth = () => {
    // Calculate the width needed for the content and add some padding
    const contentWidth = value.toString().length * 10 + 10; // Adjust the multiplier as needed
    // Return the calculated width as a string
    return `${contentWidth}px`;
  };

  // Function to focus the input element
  const focusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  // Add keyboard event listeners to the input element when it's focused
  const handleKeyDown = (e) => {
    if (!disabled) {
      if (e.key === "ArrowUp") {
        e.preventDefault(); // Prevent the default behavior of the arrow keys
        onChange((Number(value) + 1).toString());
      } else if (e.key === "ArrowDown") {
        e.preventDefault(); // Prevent the default behavior of the arrow keys
        onChange((Number(value) - 1).toString());
      }
    }
  };

  return {
    inputRef,
    calculateInputWidth,
    focusInput,
    handleKeyDown,
  };
};

export default useNumberInputData;
